import { Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import { ClientPassportButton } from "../../../../components/buttons/ClientPassportButton";
import { YesNoButton } from "../../../../components/buttons/YesNoButton";
import { StyledTableCell, StyledTableHead } from "../../../../components/table/BaseTable/BaseTable";
import { CreateTaskButton } from "../../../TaskPage/CreateTaskButton";
import { CustomerActionButton } from "../../AgreementConfigurationDialog/Tabs/components/CustomerActionButton";
import { StatusIcon } from "../../AgreementConfigurationDialog/Tabs/components/StatusIcon";
import { SharesList } from "./SharesList";

export const CustomersTab = (props) => {
    const { customers, customerShares = [] } = props;

    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={10}>
                <SharesList shares={customerShares} />
            </Grid>
            <Grid item xs={12} md={10}>
                <CustomersTable customers={customers} shares={customerShares} 
                        readOnly={props.readOnly}
                        />
            </Grid>
        </Grid>
    );
};

const isFullAgreementCustomer = (item) => {
    return !!(
        "agrecust_is_foreigner" in item &&
        "agrecust_is_customer_jdg" in item &&
        "agrecust_is_customer_nip" in item
    );
};

const CustomersTable = (props) => {
    const { customers, shares } = props;
    const { t } = useTranslation();

    const itemsToRender =
        customers && customers.length > 0
            ? customers
            : shares?.flatMap(
                  (share) => share.customers?.map((customer) => ({ customer })) || [],
              ) || [];

    const customerRow = (ac) => {
        const customer = ac?.customer;

        if (!customer) {
            return null;
        }

        const isCompany = Boolean(customer.company);
        return (
            <TableRow key={customer.id}>
                <StyledTableCell>{customer.person?.name || "-"}</StyledTableCell>
                <StyledTableCell>{customer.person?.name2 || "-"}</StyledTableCell>
                <StyledTableCell>{customer.person?.surname || "-"}</StyledTableCell>
                <StyledTableCell>{customer.company?.name || "-"}</StyledTableCell>
                <StyledTableCell>
                    {customer.person?.email?.email_address ||
                        customer.company?.email?.email_address ||
                        "-"}
                </StyledTableCell>
                <StyledTableCell>
                    {customer.person?.phone?.phone_number ||
                        customer.company?.phone?.phone_number ||
                        "-"}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isFullAgreementCustomer(ac) && ac.agrecust_is_foreigner != null ? (
                        ac?.customer?.company?.company_citizenship || ac?.customer?.person?.person_citizenship ||
                        <YesNoButton value={ac.agrecust_is_foreigner} disabled={true} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isCompany ? (
                        "-"
                    ) : isFullAgreementCustomer(ac) && ac.agrecust_is_customer_jdg != null ? (
                        <YesNoButton value={ac.agrecust_is_customer_jdg} disabled={true} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isCompany ? (
                        "-"
                    ) : isFullAgreementCustomer(ac) && ac.agrecust_is_customer_nip != null ? (
                        <YesNoButton value={ac.agrecust_is_customer_nip} disabled={true} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isCompany ? (
                        "-"
                    ) : customer.person?.has_id_documentation != null ? (
                        <StatusIcon ok={Boolean(customer.person.has_id_documentation)} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isCompany ? (
                        "-"
                    ) : customer.person?.has_detailed_info != null ? (
                        <StatusIcon ok={Boolean(customer.person.has_detailed_info)} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {isCompany ? (
                        customer.company?.has_basic_info != null ? (
                            <StatusIcon ok={Boolean(customer.company.has_basic_info)} />
                        ) : (
                            "-"
                        )
                    ) : customer.person?.has_basic_info != null ? (
                        <StatusIcon ok={Boolean(customer.person.has_basic_info)} />
                    ) : (
                        "-"
                    )}
                </StyledTableCell>
                <StyledTableCell align="center">
                    <CustomerActionButton customer={customer} />
                </StyledTableCell>
                <StyledTableCell align="center">
                    <ClientPassportButton
                        clientId={customer.id}
                        clientType={customer.company ? "company" : "customer"}
                    />
                </StyledTableCell>
                <StyledTableCell align="center">
                    {
                    !props.readOnly &&
                    <CreateTaskButton customerId={customer.id} />}
                </StyledTableCell>
            </TableRow>
        );
    };

    return (
        <TableContainer>
            <Table>
                <StyledTableHead>
                    <TableRow>
                        <StyledTableCell>{t("clients.table.firstName")}</StyledTableCell>
                        <StyledTableCell>{t("clients.table.middleName")}</StyledTableCell>
                        <StyledTableCell>{t("clients.table.lastName")}</StyledTableCell>
                        <StyledTableCell>{t("clients.table.companyName")}</StyledTableCell>
                        <StyledTableCell>{t("clients.table.email")}</StyledTableCell>
                        <StyledTableCell>{t("clients.table.phoneNumber")}</StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.isForeigner")}
                        </StyledTableCell>
                        <StyledTableCell align="center">{t("clients.table.isJdg")}</StyledTableCell>
                        <StyledTableCell align="center">{t("clients.table.isNip")}</StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.hasDocs")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.hasDetailed")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.hasBasic")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.action")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {t("clients.table.passport")}
                        </StyledTableCell>
                        <StyledTableCell align="center">{t("clients.table.task")}</StyledTableCell>
                    </TableRow>
                </StyledTableHead>
                <TableBody>{itemsToRender.map(customerRow)}</TableBody>
            </Table>
        </TableContainer>
    );
};
